import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import LandingPage from './pages/Landingpage';
import ExplorePage from './pages/Explorepage';
import LoginPage from './pages/Login';
import Signup from './pages/Signup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from "./Components/AuthContext";
import PrivateRoute from "./Components/PrivateRoute";
import CreatorDashboard from "./pages/CreatorDashboard";
import CreatorProfile from "./pages/CreatorProfile"; // ✅ Make sure casing matches your file
import Upload from "./pages/Upload";
import Watch from "./pages/Watch";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import About from './pages/About';
import Contact from './pages/Contact';
import ForgotPassword from './pages/ForgotPassword';


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
  <Route index element={<LandingPage />} />
  <Route path="explore" element={<ExplorePage />} />
  <Route path="login" element={<LoginPage />} />
  <Route path="signup" element={<Signup />} />
  <Route path="/forgot-password" element={<ForgotPassword />} />

  <Route path="dashboard" element={
    <PrivateRoute>
      <CreatorDashboard />
    </PrivateRoute>
  } />
  <Route path="creator/:creatorId" element={<CreatorProfile />} />
  <Route path="upload" element={
    <PrivateRoute>
      <Upload />
    </PrivateRoute>
  } />
</Route>
<Route path="/watch/:episodeId" element={<Watch />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
